import api from './api';
import { authService } from './authService';

export const appealService = {
  getAppeals: async () => {
    const response = await api.get('/api/dispatcher/domokey/tickets');
    return response.data.body;
  },

  getAppeal: async (ticketId) => {
    const response = await api.get(`/api/dispatcher/domokey/tickets/${ticketId}`);
    return response.data.body;
  },

  getStatuses: async () => {
    const response = await api.get('/api/dispatcher/domokey/tickets/statuses');
    return response.data.body;
  },

  getCategories: async () => {
    const response = await api.get('/api/dispatcher/domokey/tickets/categories');
    return response.data.body;
  },

  getAccountBalance: async (accountId) => {
    const response = await api.get(`/api/dispatcher/domokey/accounts/${accountId}/balance`);
    return response.data.body;
  },

  getProfile: () => authService.getProfile(),

  searchAccountsByNumber: async (number) => {
    const response = await api.get(`/api/dispatcher/domokey/accounts/by-number/${encodeURIComponent(number)}`);
    return response.data.body ?? response.data;
  },

  sendMessage: async (ticketId, messageData) => {
    const url = `/api/dispatcher/domokey/tickets/${ticketId}/messages`;
    console.log('[Domokey request]', {
      method: 'POST',
      url,
      body: messageData,
    });
    const response = await api.post(
      url,
      messageData
    );
    return response.data.body;
  },

  markMessagesViewed: async (ticketId, messageIds, employee) => {
    const params = new URLSearchParams();
    if (employee) params.append('employee', employee);
    const query = params.toString() ? `?${params.toString()}` : '';
    const response = await api.post(
      `/api/dispatcher/domokey/tickets/${ticketId}/viewings${query}`,
      messageIds
    );
    return response.data.body;
  },

  getAttachmentUrl: (ticketId, fileId, fileName) => {
    const params = new URLSearchParams();
    if (fileId) params.append('fileId', fileId);
    if (fileName) params.append('fileName', fileName);
    const query = params.toString();
    return `/api/dispatcher/domokey/tickets/${ticketId}/attachments${query ? `?${query}` : ''}`;
  },

  downloadAttachment: async (ticketId, fileId, fileName) => {
    const response = await api.get(
      `/api/dispatcher/domokey/tickets/${ticketId}/attachments`,
      {
        params: { fileId, fileName },
        responseType: 'blob',
      }
    );
    return response.data;
  },

  updateAppeal: async (ticketId, data) => {
    const response = await api.put(
      `/api/dispatcher/domokey/tickets/${ticketId}`,
      data
    );
    return response.data.body;
  },

  uploadAttachment: async (ticketId, file, { authorName, authorId } = {}) => {
    const formData = new FormData();
    formData.append('file', file);
    const params = new URLSearchParams();
    params.append('authorName', authorName ?? '');
    params.append('authorId', authorId ?? '');
    const query = params.toString() ? `?${params.toString()}` : '';
    const encodedName = encodeURIComponent(file.name);
    const fallbackName = file.name
      .replace(/[^\x20-\x7E]/g, '_')
      .replace(/[;"]/g, '_') || 'attachment';
    const url = `/api/dispatcher/domokey/tickets/${ticketId}/attachments${query}`;
    const headers = {
      'Content-Disposition': `attachment;filename=${fallbackName}; filename*=UTF-8${encodedName}`,
    };
    console.log('[Domokey request]', {
      method: 'POST',
      url,
      headers,
      file: {
        name: file.name,
        size: file.size,
        type: file.type,
      },
    });
    const response = await api.post(
      url,
      formData,
      { headers }
    );
    return response.data.body;
  },
};
